module.exports = __webpack_public_path__ + "img/gateway3_img1.0ffe3bc6.png";